export default class Polyfill {
    constructor() {
        this.ensureLogger();
    }

    ensureLogger() {
      const defaultFxn = function() {};
      const methods = ['error', 'warn', 'debug'];
      methods.forEach((method) => {
        if (!console[method])  console[method] = defaultFxn;
      });
    }
}